module.exports = __webpack_public_path__ + "static/media/TableCornerScratch_After.cd51ad83.jpg";